<template>
  <div class="footer_wrap">
    <div class="footer">
      Copyright <font class="fontfam">©</font> 2005 - {{ year }} www.med66.com All Rights Reserved.　北京正保医教科技有限公司 版权所有<br>
      客服邮箱：<a href="mailto:med66@cdeledu.com" zhuge-name="客服邮箱">med66@cdeledu.com</a>　建议邮箱：<a title="医学教育网建议邮箱账号" zhuge-name="建议邮箱" href="mailto:medjy@cdeledu.com">medjy@cdeledu.com</a><br>
      <a href="//www.med66.com/licence/icp.htm" target="_blank" title="京ICP证：京B2-20200993" zhuge-name="京ICP证">京ICP证：京B2-20200993</a>　 <a href="//beian.miit.gov.cn/" target="_blank" title="医学教育网互联网信息服务：京ICP备20013320号-1" zhuge-name="京ICP证">京ICP备20013320号-1</a>　　<a href="//www.med66.com/licence/cbw.htm" target="_blank" rel="external nofollow" title="医学教育网出版物经营许可证：京批字第直0579号" zhuge-name="出版物经营许可证">出版物经营许可证</a>　<img src="//www.med66.com/upload/html/2017/05/li040387.png" style="display:inline-block; vertical-align: middle; width: 20px; height: 20px;" border="0" width="20" height="20"><a href="//www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802020153" target="_blank" title="医学教育网京公网安备11010802020153号" zhuge-name="京公网安备">京公网安备11010802020153号</a>　
    </div>
  </div>
</template>

<script>
export default {
  name: "CommonFooter",
  data(){
    return{
      year: new Date().getFullYear()
    }
  }
}
</script>

<style scoped lang="scss">
.footer {
  line-height: 32px;
  font-size: 12px;
  font-family: \5FAE\8F6F\96C5\9ED1,\9ED1\4F53;
  text-align: center;
  color: #666;
  margin: 10px auto;
  a {
    color: #666;
  }
  .fontfam {
    font-family: Verdana,Arial,Helvetica,sans-serif;
  }
}

</style>
